export interface MitekUpdateModel {
  status: MitekUpdateStatus;
  result?: MitekUpdateResultModel;
}

export type MitekUpdateStatus = 'start' | 'acquiring' | 'success';

export interface MitekUpdateResultModel {
  docType?: string;
  imageData?: string;
  mode?: string;
  status?: string;
  warnings?: { status?: string };
}
